"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunction = void 0;
const is_async_function_1 = require("./is-async-function");
const is_sync_function_1 = require("./is-sync-function");
exports.isFunction = (value) => is_sync_function_1.isSyncFunction(value) || is_async_function_1.isAsyncFunction(value);
//# sourceMappingURL=is-function.js.map